import loadable from '@wix/yoshi-flow-editor/loadable';

export const Reactions = loadable(
  () => import(/* webpackChunkName: "LegacyReactions" */ './Reactions'),
  {
    resolveComponent: (component) => component.Reactions,
  },
);
